import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, NavLink } from "react-router-dom";
import { matchPath } from "react-router";

import AppStateStore from './AppStateStore';
import { Layout, Button, Icon, Input, Checkbox, Row, Col, Alert, Affix, Collapse } from 'antd';
import { Users, UserDetail } from './User';
import { UserModel, UserListStore } from './UsersStore';
import { Projects, ProjectDetail } from './Project';
import { UploadData } from './Upload';
import { ProjectModel, ProjectListStore } from './ProjectsStore';
import CustomFooter from './CustomFooter';
import { Sidebar } from './Sidebar';
import { CustomMap } from './Map';

import { normalizeMatchPath } from './common';

const { Header, Content, Sider } = Layout;

class Main extends React.Component {
	state = {
		sidebarCollapsed: false //this is not so important do be included in the appStateStore...
	};

	//projectListStore = new ProjectListStore({ model: ProjectModel, auth: this.context });

	constructor(props) {
		super(props);
		this.projectListStore = new ProjectListStore({ model: ProjectModel, auth: this.props.authStore });
		this.appStateStore = new AppStateStore();
	}

	menu = [
		{ key: "1", to: "/", iconType: "global", text: "Projects", isDefault: true }
		,{ key: "2", to: "/users", iconType: "user", text: "Users" }
		,{ key: "3", to: "/upload", iconType: "upload", text: "Upload" }
	];

	onCollapse = (collapsed) => {
		console.log(collapsed);
		this.setState({ sidebarCollapsed: collapsed });
	}

	toggleSidebar = () => {
		this.setState( (prevState, props) => ({
			sidebarCollapsed: !prevState.sidebarCollapsed
		}));
	}

	logout = () => {
		this.context.logout().then( () => {
			this.props.history.push('/');
		});
	}

	render() {
		return (
		<Layout style={{ minHeight: '100vh' }}>
			<Sidebar collapsed={this.state.sidebarCollapsed} onCollapse={this.onCollapse} stateStore={this.appStateStore} />
			<Layout>
				{/*<Header style={{ background: '#fff', padding: 0 }}>
					<Row>
						<Col span={12}>
							<Icon className="sidebar-trigger" type={this.state.sidebarCollapsed ? 'menu-unfold' : 'menu-fold'} onClick={this.toggleSidebar} />
						</Col>
						<Col span={12}>
							<div className="login-info">
								<span>Logged in as:</span> <strong className="username">{this.context.email}</strong>  &nbsp;|&nbsp; <a className="logout" onClick={this.logout}>Logout</a>
							</div>
						</Col>
					</Row>
				</Header>*/}
				<Content style={{ margin: 0, height: '100%' }}>
					<CustomMap
						googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyC5gtmsIDSo8f9amwMgFew6xly_J_trKBY"
						loadingElement={<div style={{ height: `100%` }} />}
						containerElement={<div style={{ height: `100%` }} />}
						mapElement={<div style={{ height: `100%` }} />}
						stateStore={this.appStateStore} 
					/>
				</Content>
				{/* <CustomFooter /> */}
			</Layout>
		</Layout>
		);
	}
}

function component404(props) {
	return <Alert message="Not found" description="This page does not exist" type="error" showIcon />
}

export default Main;
